import { CanceledIcon } from "@images/svgIcons/canceledIcon"
import { CollectionIcon } from "@images/svgIcons/collectionIcon"
import { FailedIcon } from "@images/svgIcons/failedIcon"
import { PendingIcon } from "@images/svgIcons/pendingIcon"
import { ReceivedIcon } from "@images/svgIcons/receivedIcon"
import { TransitIcon } from "@images/svgIcons/transitIcon"
import { word } from "@modules/core/utils/i18n"
import { PayoutTransferStatus } from "@modules/finances/types/financesType"
import { StripeAccountErrorCode } from "@modules/finances/types/stripeErrorTypes"

export const getFinanceStatisticsStatusText = (status?: PayoutTransferStatus | null): string => {
  switch (status) {
    case PayoutTransferStatus.PENDING:
      return word("finance.payoutTransferStatus.pending")
    case PayoutTransferStatus.IN_TRANSIT:
      return word("finance.payoutTransferStatus.inTransit")
    case PayoutTransferStatus.PAID:
      return word("finance.payoutTransferStatus.paid")
    case PayoutTransferStatus.CANCELED:
      return word("finance.payoutTransferStatus.canceled")
    case PayoutTransferStatus.FAILED:
      return word("finance.payoutTransferStatus.failed")
    default:
      return word("finance.payoutTransferStatus.collection")
  }
}
export const getFinanceStatisticsStatusIcon = (
  color: string,
  status?: PayoutTransferStatus | null,
): React.JSX.Element => {
  switch (status) {
    case PayoutTransferStatus.PENDING:
      return <PendingIcon color={color} />
    case PayoutTransferStatus.IN_TRANSIT:
      return <TransitIcon color={color} />
    case PayoutTransferStatus.PAID:
      return <ReceivedIcon color={color} />
    case PayoutTransferStatus.CANCELED:
      return <CanceledIcon color={color} />
    case PayoutTransferStatus.FAILED:
      return <FailedIcon color={color} />
    default:
      return <CollectionIcon color={color} />
  }
}

export const getStripeAccountErrorText = (
  errorCode: StripeAccountErrorCode,
): { alertTitle: string; alertContent: string; primaryButtonLabel: string } => {
  if (errorCode === StripeAccountErrorCode.IS_MISSING_DOCUMENT)
    return {
      alertTitle: word("global.stripeError.missingDocument.title"),
      alertContent: word("global.stripeError.missingDocument.content"),
      primaryButtonLabel: word("global.stripeError.missingDocument.buttonLabel"),
    }

  return {
    alertTitle: word("global.stripeError.unknownError.title"),
    alertContent: word("global.stripeError.unknownError.content"),
    primaryButtonLabel: word("global.stripeError.unknownError.buttonLabel"),
  }
}
